import ViewManager from './core/controllers/ViewManager.js';
import Assets from "./core/controllers/Assets";
import Model from "./core/model/Model";
import Layout from "./core/controllers/Layout";
import GameController from "./core/controllers/GameController";
import Config from "./const/Config";
import Locale from "./core/controllers/Locale";
import SoundController from './core/controllers/SoundController.js';
import LocalData from "./core/controllers/LocalData";

import "pixi.js";
import "gsap";
import "howler";
import C_GameEvent from "./core/const/C_GameEvent";


window.onload = function()
{
    let START_WIDTH;
    let START_HEIGHT;

    if (isLandscape())
    {
        // LANDSCAPE
        START_WIDTH = Math.max(window.screen.width, window.screen.height);
        START_HEIGHT = START_WIDTH * 9/16;
    }
    else
    {
        // PORTRAIT
        START_HEIGHT = Math.max(window.screen.width, window.screen.height);
        START_WIDTH = START_HEIGHT * 9/16;
    }

    function isLandscape()
    {
        return false;
    }

    function isMobile() {
        if( navigator.userAgent.match(/Android/i)
            || navigator.userAgent.match(/webOS/i)
            || navigator.userAgent.match(/iPhone/i)
            || navigator.userAgent.match(/iPad/i)
            || navigator.userAgent.match(/iPod/i)
            || navigator.userAgent.match(/BlackBerry/i)
            || navigator.userAgent.match(/Windows Phone/i)
        ){
            return true;
        }
        else {
            return false;
        }
    }

    let urlParams = {};
    location.search.substr(1).split("&").forEach(
        function (item)
        {
            let tmp = item.split("=");
            if (tmp[0].length > 0)
            {
                urlParams[tmp[0]] = decodeURIComponent(tmp[1]);
            }
        });

    let dpr = window.devicePixelRatio || 1;
    console.log("START_WIDTH: " + START_WIDTH + " START_HEIGHT: " + START_HEIGHT);
    let app = new PIXI.Application(START_WIDTH, START_HEIGHT, {backgroundColor: 0x000000, resolution:dpr});
    PIXI.app = app;
    app.config = new Config();
    app.gFactory = isLandscape() ? new GameFactoryLandscape : new GameFactoryPortrait;
    app.layout = new Layout(START_WIDTH, START_HEIGHT);
    app.layout.setIsMobile(isMobile());
    window.onresize = onResize;
    // document.body.appendChild(app.view);
    document.getElementById("content").appendChild(app.view);
    onResize();

    // Loaders path based on view mode
    let assetsPath = isLandscape() ? "assets/landscape/" : "assets/portrait/";

    let bootLoader = new PIXI.loaders.Loader();

    bootLoader
        .add('splash', assetsPath + 'splash_screen.jpg')
        .add('logo', assetsPath + 'logo.png')
        .add('logoLight', assetsPath + 'logo_light.png')
        .add('loadBarBg', assetsPath + 'loading_circle_back.png')
        .add('loadBarCircle', assetsPath + 'loading_circle_progress.png')
        .add('loadLock', assetsPath + 'loading_inside.png')
        .add('dynamicAssets', 'dynamicAssets.txt')
        .load(bootComplete);

    let splashBg = null;
    let splashOver = null;
    let logo = null;
    let logoLight = null;
    let loadBarBg = null;
    let loadProgress = null;
    let loaderMask = null;
    let loadLock = null;
    let tf1 = null;

    let angle = {min: -Math.PI/2, max: 0 - Math.PI/2};

    function bootComplete(loader)
    {
        let assetsForLoad = isLandscape() ? app.config.landscapeAssets : app.config.portraitAssets;
        for (let asset in assetsForLoad)
        {
            PIXI.loader.add(asset, assetsPath + assetsForLoad[asset]);
        }
        // PIXI.loader
        //     .add('hand', assetsPath + 'hand.png')
        //     .add('atlas', assetsPath + 'sheet1.json')
        //     .add('atlas2', assetsPath + 'sheet2.json')
        //     .add('atlas3', assetsPath + 'sheet3.json')
        //     .add('atlas4', assetsPath + 'sheet4.json')
        //     .add('atlas6', assetsPath + 'sheet5.json')
        //     .add('atlas5', assetsPath + 'PaytableAtlas.json')
        //     .add('shine', 'assets/shaders/shine.frag')
        //     .add('desat', 'assets/shaders/desat.frag')
        //     .add('frame_filter', 'assets/shaders/frame.frag')
        //     .add('locale', 'assets/locale/localization_en.json');

        PIXI.loader
            .add('shine', 'assets/shaders/shine.frag')
            .add('desat', 'assets/shaders/desat.frag')
            .add('frame_filter', 'assets/shaders/frame.frag')
            .add('locale', 'assets/locale/localization_en.json');

        let dynamicAssetPaths = JSON.parse(loader.resources.dynamicAssets.data).paths;
        for (let assetIdx=0; assetIdx < dynamicAssetPaths.length; assetIdx++)
        {
            let assetPath = dynamicAssetPaths[assetIdx];
            let regExp = /([^\/\\&\?]+\.\w{3,4})/g;
            let assetName = regExp.exec(assetPath)[1];
            PIXI.loader.add(assetName, assetPath, {loadType:"XHR", xhrType:"blob"});
        }

        splashBg = new PIXI.Sprite(loader.resources.splash.texture);
        app.layout.propHeightScale(splashBg, 100);
        app.stage.addChild(splashBg);

        splashOver = new PIXI.Graphics();
        splashOver.beginFill(0x000000, .36);
        splashOver.drawRect(splashBg.x, splashBg.y, splashBg.width, splashBg.height);
        app.stage.addChild(splashOver);

        logo = new PIXI.Sprite(loader.resources.logo.texture);
        app.layout.propHeightScale(logo, 30);
        app.layout.horizontalAlignCenter(logo);
        app.layout.verticalAlignTop(logo, 20);
        app.stage.addChild(logo);

        logoLight = new PIXI.Sprite(loader.resources.logoLight.texture);
        app.layout.propHeightScale(logoLight, 30);
        app.layout.horizontalAlignCenter(logoLight);
        logoLight.y = logo.y;
        app.stage.addChild(logoLight);

        loadBarBg = new PIXI.Sprite(loader.resources.loadBarBg.texture);
        app.layout.propHeightScale(loadBarBg, 13);
        loadBarBg.anchor.set(0.5);
        app.layout.horizontalAlignCenter(loadBarBg);
        app.layout.verticalAlignTop(loadBarBg, 61);
        app.stage.addChild(loadBarBg);

        loadProgress = new PIXI.Sprite(loader.resources.loadBarCircle.texture);
        app.layout.propHeightScale(loadProgress, 13);
        loadProgress.anchor.set(0.5);
        loadProgress.x = loadBarBg.x;
        loadProgress.y = loadBarBg.y;
        app.stage.addChild(loadProgress);

        loaderMask = new PIXI.Graphics();
        loaderMask.lineStyle(loadProgress.width*.2, 0xff0000);
        // loaderMask.beginFill(0xffffff);
        loaderMask.arc(loadBarBg.x, loadBarBg.y, loadBarBg.width*.4, angle.min, angle.max, false);
        loaderMask.endFill();
        app.stage.addChild(loaderMask);

        loadProgress.mask = loaderMask;


        loadLock = new PIXI.Sprite(loader.resources.loadLock.texture);
        app.layout.propHeightScale(loadLock, 13);
        loadLock.anchor.set(0.5);
        loadLock.x = loadBarBg.x;
        loadLock.y = loadBarBg.y;
        app.stage.addChild(loadLock);

        let style = {fontFamily: "Khand"};
        tf1 = new PIXI.Text("", style);
        app.stage.addChild(tf1);

        PIXI.loader
            .on('progress', handleProgress, this)
            .load(preloadComplete);

        loadLockRotate();
        testMaskAnimation();
    }


    function loadLockRotate()
    {
        // TweenMax.to(loadLock, .3, {rotation: loadLock.rotation + 2*Math.PI*(0.5 - Math.random())});
        // TweenMax.delayedCall(.3, loadLockRotate, null, this);
        TweenMax.to(loadLock, 1, {rotation: 2*Math.PI, repeat: -1, ease: Linear.easeNone});
    }


    function testMaskAnimation()
    {

    }


    function handleProgress(loader)
    {
        let progress = Math.round(loader.progress) / 100;
        console.log('Loading... ' + (progress * 100).toFixed(0) + '%');

        angle.max = progress*Math.PI*2 - Math.PI/2;
        loaderMask.clear();
        loaderMask.lineStyle(loadProgress.width*.2, 0xff0000);
        loaderMask.arc(loadBarBg.x, loadBarBg.y, loadBarBg.width/2, angle.min, angle.max, false);
        loaderMask.endFill();
    }


    function preloadComplete()
    {
        PIXI.loader.removeListener('progress', handleProgress, this);

        app.localData = new LocalData();
        app.nav = new ViewManager();
        app.assets = new Assets();
        app.model = new Model();
        app.dispatcher = new PIXI.utils.EventEmitter();
        app.controller = new GameController();
        app.locale = new Locale();
        app.sound = new SoundController();

        //app.sound.playSound('show_winnings');

        // This is needed because the first time a web font is used it is not displayed correctly,
        // so we add a dummy text field to prepare it
        let tf = app.assets.getTF("", 2, 'Khand');
        tf.alpha = 0.01;
        app.stage.addChild(tf);

        tf = app.assets.getTF('', 2, 'Captain');
        tf.alpha = 0.01;
        app.stage.addChild(tf);

        app.dispatcher.once(C_GameEvent.NAVIGATE, disposeBootLoader);
        // app.controller.setupApp();
        app.controller.showSplashScreen();
    }


    function disposeBootLoader()
    {
        app.stage.removeChild(splashBg);
        splashBg = null;

        app.stage.removeChild(splashOver);
        splashOver = null;

        app.stage.removeChild(logo);
        logo = null;

        app.stage.removeChild(logoLight);
        logoLight = null;

        app.stage.removeChild(loadBarBg);
        loadBarBg = null;

        app.stage.removeChild(loadProgress);
        loadProgress = null;

        app.stage.removeChild(loaderMask);
        loaderMask = null;

        app.stage.removeChild(tf1);
        tf1 = null;

        TweenMax.killDelayedCallsTo(loadLockRotate);
        TweenMax.killTweensOf(loadLock);
        app.stage.removeChild(loadLock);
        loadLock = null;

        for (let key in bootLoader.resources)
        {
            let t = bootLoader.resources[key].texture;
            if (t)
            {
                t.destroy();
            }
        }
    }


    function onResize()
    {
        let scale = 'scale(1)';
        // document.body.style.webkitTransform = scale;    // Chrome, Opera, Safari
        // document.body.style.msTransform = scale;        // IE 9
        // document.body.style.transform = scale;          // General

        let vpWidth = window.innerWidth;
        let vpHeight = window.innerHeight;

        console.log("innerWidth : " + window.innerWidth + " innerHeight : " + window.innerHeight);

        let landscape = vpWidth > vpHeight;

        let scaleFactor, newWidth, newHeight;


        scaleFactor = Math.min(vpWidth / START_WIDTH, vpHeight / START_HEIGHT);
        newWidth = Math.ceil(START_WIDTH * scaleFactor);
        newHeight = Math.ceil(START_HEIGHT * scaleFactor);

        handleCorrect();


        // if (!landscape)
        // {
        //     scaleFactor = Math.min(vpWidth / START_WIDTH, vpHeight / START_HEIGHT);
        //     newWidth = Math.ceil(START_WIDTH * scaleFactor);
        //     newHeight = Math.ceil(START_HEIGHT * scaleFactor);
        //
        //     handleCorrect();
        // }
        // else
        // {
        //     scaleFactor = vpWidth / START_WIDTH;
        //     newWidth = vpWidth;
        //     newHeight = vpHeight;
        //
        //     handleIncorrect();
        // }

        console.log("Resizing to w:" + newWidth + " h:" + newHeight + " scaleFactor:" + scaleFactor);

        app.renderer.view.style.width = `${newWidth}px`;
        app.renderer.view.style.height = `${newHeight}px`;

        app.renderer.resize(newWidth, newHeight);
        app.stage.scale.set(scaleFactor);
        app.layout.onResize(newWidth, newHeight);
    }


    function handleIncorrect()
    {
        document.getElementById("turn").style.display="block";
    }


    function handleCorrect()
    {
        document.getElementById("turn").style.display="none";
    }

};

import SplashScreen from "./views/SplashScreen";
import GameFactoryLandscape from "./core/controllers/GameFactoryLandscape";
import GameFactoryPortrait from "./core/controllers/GameFactoryPortrait";
var onSwipe = SplashScreen.onSwipe;


export { onSwipe }